import SMFormFieldPhone from './SMFormFieldPhone';

export default SMFormFieldPhone;
